module.exports = __webpack_public_path__ + "4c9af0bc72d0620abff947480bd788b8.jpg";